// extracted by mini-css-extract-plugin
export default {"titleWrapper":"App_titleWrapper__V-iFs"};